import { CarEquipmentData } from '../../../../@types';

const initialState: CarEquipmentData[] = [];

export default initialState;
